export default function () {
    document.addEventListener('copy', function (ev) {
        ev.preventDefault();
        let text = document.getSelection().toString();
        text = text.split(String.fromCharCode(8203)).join('');
        ev.clipboardData.setData('text', text);
    });
}
